/* 🤖 this file was generated by svg-to-ts */
export const matIconLocalParking: {
  name: 'local-parking';
  data: string;
} = {
  name: 'local-parking',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"/></svg>`
};
